/**
 * Removes a class if the element has it. Adds it if not.
 * @param {HTMLElement} element The element to toggle the class on.
 * @param {string} cssClass The css class you wish to toggle.
 * @example toggleClass(myELement, 'active');
 */
const toggleClass = (element: HTMLElement, cssClass: string): void => {
  if (element.classList.contains(cssClass)) {
    element.classList.remove(cssClass)
  } else {
    element.classList.add(cssClass)
  }
}

export default toggleClass
